import React, { Fragment } from "react";
import { Header, Segment, Icon, Image } from "semantic-ui-react";

import IObservation, { EObservationStatus, EProcessingMarkingPublicity, IProcessForm } from "../../../interfaces/IObservation";
import { PersonName } from "../../person/PersonName";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { StatusColors } from "../../../constants/statusColors";
import { getTranslatedStatusTexts } from "../../../constants/statusTextKey";
import { TFunction } from "i18next";
import { getLatestProcessingMarking } from "../../../utils/havainnot.helper";
import { useApplicationConfiguration } from "../../../configuration/ConfigurationContext";
import { ImageView } from "../../../../../sg-fileupload";

const getTextProps = (t: TFunction) => ({
    handlerMarkings: t("Käsittelijän merkinnät"),
    handler: t("Käsittelijä"),
    sender: t("Lähettäjä"),
    forwarded: t("Välitetty"),
    time: t("Aika"),
    reciever: t("Vastaanottaja"),
    classification: t("Luokittelu")
})

interface IProcessingDetail {
    observation: IObservation;
    userIsEditor: boolean;
}

const ProcessingDetail: React.FC<IProcessingDetail> = (props) => {
    const config = useApplicationConfiguration()
    const { observation, userIsEditor } = props
    const translate = useTranslation().t;

    const texts = getTextProps(translate);
    const processMarkings = observation.formData.merkinnat
    const customProcessingForm = observation.processingFormSchema

    if (!processMarkings) {
        return null
    }

    const statusTexts = getTranslatedStatusTexts(translate);
    const getStatusIcon = (status: any) => < Icon name="circle" color={(StatusColors as any)[status]} />

    const latestMarking = getLatestProcessingMarking(observation);
    const publicityStatus = latestMarking?.formData.kasittelymerkintojen_julkisuus || config.processingMarkingPublicityDefaultValue;;

    const renderMarking = (marking: IProcessForm, index: number) => (
        <Segment key={index}>
            <div style={{ display: 'd-flex', alignItems: 'center' }}>
                {marking.formData.valitetty ? (
                    <>  < Icon name="mail forward" color="grey" />  {texts.forwarded}    </>
                ) : (<> {getStatusIcon(marking.formData.tila)}{statusTexts[marking.formData.tila as EObservationStatus]}</>)}
            </div>
            <div>
                {marking.formData.valitetty ? texts.sender : texts.handler}{": "}
                {marking.creator ? <PersonName personId={marking.creator} /> : null}
            </div>
            <div>
                {texts.time}:  {moment(marking.created_at).format('DD.MM.YYYY HH:mm')}
            </div>
            {marking.formData.luokitteluteksti && (
                <div>
                    {texts.classification}:  {Array.isArray(marking.formData.luokitteluteksti) ? marking.formData.luokitteluteksti.join(", ") : marking.formData.luokitteluteksti}
                </div>
            )}
            {marking.formData.lisatiedot}
            {marking.formData.kuvat && marking.formData.kuvat.length ? (
                <Image.Group size="tiny" className="rounded" >
                    {marking.formData.kuvat.map((file: any) => (
                        <ImageView key={file.id} id={file.id} />
                    ))}
                </Image.Group>
            ) : null}
            {marking.formData.valitetty && (
                <>{texts.reciever}:{" "}  {marking.formData.vastaanottaja ? (<PersonName personId={marking.formData.vastaanottaja} />) : "-"}</>
            )}
        </Segment>
    );

    if (publicityStatus === EProcessingMarkingPublicity.All || userIsEditor) {
        return (
            <Fragment>
                <Header> {texts.handlerMarkings} </Header>
                {processMarkings.map(renderMarking)}
            </Fragment>
        );
    };

    if (publicityStatus === EProcessingMarkingPublicity.Last) {
        return (
            <Fragment>
                <Header> {texts.handlerMarkings} </Header>
                {latestMarking ? renderMarking(latestMarking, 0) : null}
            </Fragment>
        );
    };

    return null
};

export default ProcessingDetail;